import _ from "lodash"
import { useField, useFormikContext } from "formik"

//PrimeReact
import { InputSwitch } from "primereact/inputswitch"

//Styles
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"

export default function WizardPageFieldsNodeCheckbox({
  rowData,
  fields,
  fieldName,
}) {
  const requiredFieldName = "required"
  const showFieldName = "show"
  const modifiedFieldName = "modified"

  const { setFieldValue } = useFormikContext()

  const fieldInstance = fields.find(
    (field) =>
      field.blockId === rowData.data.blockId &&
      field.fieldId === rowData.data.fieldId
  )
  const indexOf = fields.indexOf(fieldInstance || {})
  const [field, , helper] = useField(`fields[${indexOf}].${fieldName}`)
  const [requiredField, ,] = useField(`fields[${indexOf}].${requiredFieldName}`)
  const [, , showHelper] = useField(`fields[${indexOf}].${showFieldName}`)
  const [, , modifiedHelper] = useField(
    `fields[${indexOf}].${modifiedFieldName}`
  )

  if (!fieldInstance) {
    return <>Unknown field</>
  }

  let isRequiredField =
    fieldInstance?.systemRequired ||
    (requiredField.value && fieldName !== requiredFieldName)

  let checkedValue = field.value

  //Parent values
  const myParentField = fields.find(
    (field) =>
      field.blockId === rowData.data.parentBlockId &&
      field.fieldId === rowData.data.parentFieldId
  )

  if (isRequiredField && myParentField && !myParentField?.show) {
    checkedValue = false
    isRequiredField = false
  }

  const ShowParent = (child) => {
    //Find the parent
    const parentField = fields.find(
      (field) =>
        field.blockId === child.blockId && field.fieldId === child.parentFieldId
    )

    if (!parentField?.show) {
      const indexOfParent = fields.indexOf(parentField)

      if (indexOfParent >= 0) {
        //Set the parent field to show
        setFieldValue(`fields[${indexOfParent}].${showFieldName}`, true)
        //Set the parent field to modified
        setFieldValue(`fields[${indexOfParent}].${modifiedFieldName}`, true)
      }

      if (parentField?.parentFieldId) {
        //If the parent has a parent, update that parent as well
        ShowParent(parentField)
      }
    }
  }

  //A recursive function to update all children of a parent
  const HideChildren = (parent) => {
    parent.children.forEach((child) => {
      //Find the child field
      const childField = fields.find(
        (field) =>
          field.blockId === child.blockId && field.fieldId === child.fieldId
      )

      if (childField) {
        //Disable the show flag of the child if it is not a system required field
        if (childField.show && !childField.systemRequired) {
          const indexOfChild = fields.indexOf(childField)

          //Set the child field to not show
          setFieldValue(`fields[${indexOfChild}].${showFieldName}`, false)
          //Set the child field to not to be required
          setFieldValue(`fields[${indexOfChild}].${requiredFieldName}`, false)
          //Set the child field to modified
          setFieldValue(`fields[${indexOfChild}].${modifiedFieldName}`, true)
        }

        //If the child has children, update those as well
        if (!_.isEmpty(childField.children)) {
          HideChildren(childField)
        }
      }
    })
  }

  return (
    <div className={kioskStyles.switchControl}>
      <InputSwitch
        checked={checkedValue}
        disabled={isRequiredField}
        onChange={(e) => {
          //If the required field is set to true ensure that the show is also set
          if (fieldName === requiredFieldName) {
            if (e.value) {
              showHelper.setValue(true)
            }
          }

          //indicate that the field has been modified
          modifiedHelper.setValue(true)
          //set the new value
          helper.setValue(e.value)

          //Set the parent value if there is one
          if (e.value && myParentField && !myParentField?.show) {
            ShowParent(fieldInstance)
          }

          //Update children if the parent is being hidden
          if (
            !e.value &&
            fieldName === showFieldName &&
            !_.isEmpty(fieldInstance?.children)
          ) {
            HideChildren(fieldInstance)
          }
        }}
      />
    </div>
  )
}
